var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Footbar"},[_vm._t("default"),_c('div',{staticClass:"footbar"},[_vm._t("footbar")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }